import { Volume2, VolumeX } from "lucide-react";
import { useMusic } from "@/context/MusicContext";

// Global signature-music control available on every page of the app shell.
// Tap to stop the music at any time; tap again to resume from where it left off.
export default function MusicToggle({ variant = "inline" }) {
  const music = useMusic();
  if (!music) return null;
  const { audible, muted, play, pause, toggleMute } = music;

  const handle = () => {
    if (audible) { pause(); }               // stop the music
    else { play(); if (muted) toggleMute(); } // resume from current position, audibly
  };

  const label = audible ? "Stop music" : "Play music";
  const Icon = audible ? Volume2 : VolumeX;

  if (variant === "floating") {
    return (
      <button data-testid="global-music-toggle-mobile" onClick={handle} aria-label={label} title={label}
        className="lg:hidden fixed left-4 bottom-[calc(6rem_+_env(safe-area-inset-bottom))] z-40 h-12 w-12 rounded-full flex items-center justify-center bg-[#291B2D] text-[#FCFAF6] shadow-[0_10px_28px_rgba(41,27,45,0.32)] hover:bg-[#352238] transition-smooth">
        <Icon size={18} strokeWidth={1.9} />
      </button>
    );
  }

  return (
    <button data-testid="global-music-toggle" onClick={handle} aria-label={label} title={label}
      className="inline-flex items-center justify-center h-10 w-10 rounded-full border border-[#291B2D]/10 bg-white text-[#291B2D]/70 hover:text-[#291B2D] hover:bg-[#F7F2EA] transition-smooth">
      <Icon size={16} strokeWidth={1.75} />
    </button>
  );
}
